import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import theme from 'components/theme';

export const StyledCardCollection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 26px;

  ${mediaDesktop} {
    display: grid;
    grid-template-columns: repeat(auto-fit, 320px);
    gap: 54px;
    justify-content: center;
  }
`;

export const StyledCollectionContainer = styled.section<{ isCollectedCollection?: boolean }>`
  padding: ${(props) => (props.isCollectedCollection ? '20px 0 0' : '36px 24px 25px')};
  background: ${theme.colors.black};

  ${mediaDesktop} {
    padding: ${(props) => (props.isCollectedCollection ? '0' : '102px')} 0 0;
    display: grid;
    place-content: center;
    grid-template-columns: minmax(max-content, 1180px);
  }
`;
